import AdtProductListTable from "./adtProductListTable.container";

export default AdtProductListTable;
